/**
 * ANSI color codes for different log levels.
 * Degrade gracefully in environments that do not support colors.
 */
export const COLORS = {
  debug: "\u001B[90m", // Gray
  log: "\u001B[37m", // White
  info: "\u001B[34m", // Blue
  warn: "\u001B[33m", // Yellow
  error: "\u001B[31m", // Red
  reset: "\u001B[0m",
};
